import React from 'react'

import { withStyles } from '@material-ui/core/styles'
import InfoIcon from '@material-ui/icons/Info'
import PropTypes from 'prop-types'

const styles = theme => ({
  root: {
    display: 'inline-flex',
    color: '#737373'
  }
})

class DrawerAboutIcon extends React.Component {
  constructor (props) {
    super(props)
    this.pure = {}
    this.pure.title = 'About'
    this.pure.headerIcon = <InfoIcon fontSize="large"/>
  }

  render () {
    const { classes } = this.props
    return (
      <div className={classes.root}>
        {this.pure.headerIcon}
      </div>
    )
  }
}

DrawerAboutIcon.propTypes = {
  classes: PropTypes.object.isRequired
}

export default (
  withStyles(styles)(
    DrawerAboutIcon
  )
)
